import { render, staticRenderFns } from "./EditImageSidebar.vue?vue&type=template&id=d4f4fcd0&scoped=true&"
import script from "./EditImageSidebar.vue?vue&type=script&lang=ts&"
export * from "./EditImageSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./EditImageSidebar.vue?vue&type=style&index=0&id=d4f4fcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f4fcd0",
  null
  
)

export default component.exports